// @flow

import {createActions, createReducer} from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  getSpecificPatientRequest: ['id'],
  getSpecificPatientSuccess: ['updatePatient'],
  getSpecificPatientError: ['error'],
  getSpecificPatientDocumentRequest: ['patient'],
  getSpecificPatientDocumentSuccess: ['doc'],
  getSpecificPatientDocumentError: ['error'],
  updateSpecificPatientRequest: ['patient'],
  updateSpecificPatientSuccess: ['updatePatient'],
  updateSpecificPatientError: ['error'],
  updateSpecificPatientSignRequest: ['patient'],
  updateSpecificPatientSignSuccess: ['updatePatient'],
  updateSpecificPatientSignError: ['error'],
  createSpecificPatientRequest: ['patient'],
  createSpecificPatientSuccess: ['patient'],
  createSpecificPatientError: ['error']
});

export const SpecificPatientTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  patientInfo: undefined,
  docInfo: undefined,
  error: undefined,
  isPatientUpdate: false
});

/* ------------- Reducers ------------- */

export const specificPatientRequest = (state: Object, action) => state.merge({
  fetching: true,
  patientInfo: undefined,
  error: undefined,
  isPatientUpdate: false
});

export const specificPatientSuccess = (state: Object, {updatePatient}: Object) => {
  return state.merge({
    fetching: false,
    patientInfo: updatePatient,
    error: undefined,
    isPatientUpdate: false
  });
}

export const specificPatientError = (state: Object, {error}: Object) => state.merge({
  fetching: false,
  error,
  patientInfo: undefined,
  roles: undefined,
  isPatientUpdate: false
});

export const specificPatientDocumentRequest = (state: Object, action) => state.merge({
  // docInfo: undefined,
  // isPatientUpdate: false
});

export const specificPatientDocumentSuccess = (state: Object, {doc}: Object) => {
  return state.merge({
    // fetching: false,
    // docInfo: doc,
    // error: undefined,
    // isPatientUpdate: false
  });
}

export const specificPatientDocumentError = (state: Object, {error}: Object) => state.merge({
  // fetching: false,
  // error,
  // docInfo: undefined,
  // roles: undefined,
  // isPatientUpdate: false
});

export const processUpdateSpecificPatientRequest = (state: Object) => {
  return state.merge({
    fetching: true,
    patientInfo: undefined,
    error: undefined,
    isPatientUpdate: false
  });
}

export const processUpdateSpecificPatientSuccess = (state: Object, {updatePatient}: Object) => {
  return state.merge({
    fetching: false,
    patientInfo: updatePatient,
    error: undefined,
    isPatientUpdate: true
  });
};

export const processUpdateSpecificPatientError = (state: Object, {error}: Object) => state.merge({
  fetching: false,
  error,
  isPatientUpdate: false
});

export const processUpdateSpecificPatientSignRequest = (state: Object) => {
  return state.merge({
    fetching: true,
    patientInfo: undefined,
    error: undefined,
    isPatientUpdate: false
  });
}

export const processUpdateSpecificPatientSignSuccess = (state: Object, {updatePatient}: Object) => {
  return state.merge({
    fetching: false,
    patientInfo: updatePatient,
    error: undefined,
    isPatientUpdate: true
  });
};

export const processUpdateSpecificPatientSignError = (state: Object, {error}: Object) => state.merge({
  fetching: false,
  error,
  isPatientUpdate: false
});

export const processCreateSpecificPatientRequest = (state: Object) => {
  return state.merge({
    fetching: true,
    patientInfo: undefined,
    error: undefined,
    isPatientUpdate: false
  });
}

export const processCreateSpecificPatientSuccess = (state: Object, {patient}: Object) => {
  return state.merge({
    fetching: false,
    patientInfo: patient,
    error: undefined,
    isPatientUpdate: true
  });
};

export const processCreateSpecificPatientError = (state: Object, {error}: Object) => state.merge({
  fetching: false,
  error,
  isPatientUpdate: false
});

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_SPECIFIC_PATIENT_REQUEST]: specificPatientRequest,
  [Types.GET_SPECIFIC_PATIENT_SUCCESS]: specificPatientSuccess,
  [Types.GET_SPECIFIC_PATIENT_ERROR]: specificPatientError,
  [Types.GET_SPECIFIC_PATIENT_DOCUMENT_REQUEST]: specificPatientDocumentRequest,
  [Types.GET_SPECIFIC_PATIENT_DOCUMENT_SUCCESS]: specificPatientDocumentSuccess,
  [Types.GET_SPECIFIC_PATIENT_DOCUMENT_ERROR]: specificPatientDocumentError,
  [Types.UPDATE_SPECIFIC_PATIENT_REQUEST]: processUpdateSpecificPatientRequest,
  [Types.UPDATE_SPECIFIC_PATIENT_SUCCESS]: processUpdateSpecificPatientSuccess,
  [Types.UPDATE_SPECIFIC_PATIENT_ERROR]: processUpdateSpecificPatientError,
  [Types.UPDATE_SPECIFIC_PATIENT_SIGN_REQUEST]: processUpdateSpecificPatientSignRequest,
  [Types.UPDATE_SPECIFIC_PATIENT_SIGN_SUCCESS]: processUpdateSpecificPatientSignSuccess,
  [Types.UPDATE_SPECIFIC_PATIENT_SIGN_ERROR]: processUpdateSpecificPatientSignError,
  [Types.CREATE_SPECIFIC_PATIENT_REQUEST]: processCreateSpecificPatientRequest,
  [Types.CREATE_SPECIFIC_PATIENT_SUCCESS]: processCreateSpecificPatientSuccess,
  [Types.CREATE_SPECIFIC_PATIENT_ERROR]: processCreateSpecificPatientError
});
